import React, { useState, useEffect } from 'react';
import { Layout, Typography, Card, Spin, message } from 'antd';
import axios from 'axios';
import { apiUrl } from './config';
import { Preferences } from '@capacitor/preferences';

const { Content } = Layout;
const { Text } = Typography;

const TrainerHistory = () => {
    const [completedRequests, setCompletedRequests] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Funzione per recuperare le richieste evase
        const fetchCompletedRequests = async () => {
            try {
                const token = (await Preferences.get({ key: 'token' })).value;
                const response = await axios.get(`${apiUrl}/api/trainer/completedRequests`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                setCompletedRequests(response.data);
            } catch (error) {
                message.error('Errore durante il recupero delle richieste completate.');
                console.error('Errore durante il recupero delle richieste completate:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchCompletedRequests();
    }, []);

    return (
        <Layout style={{ minHeight: '100vh' }}>
            <Content style={{ maxWidth: '800px', margin: '0 auto' }}>
                <div className="dashboard-title">
                    STORICO RICHIESTE EVASE
                </div>

                {loading ? (
                    <Spin size="large" style={{ display: 'block', margin: '2rem auto' }} />
                ) : (
                    completedRequests.length > 0 ? (
                        completedRequests.map((request, index) => (
                            <Card key={index} style={{ marginBottom: '1rem' }} bordered>

                                <Typography.Title level={4}>
                                    Richiesta da: \n{request.email}
                                </Typography.Title>
                                <Text>
                                    <strong>Frequenza settimanale:</strong> {request.frequenza} volte
                                </Text>
                                <br />
                                <Text>
                                    <strong>Focus:</strong> {request.focus}
                                </Text>
                                <br />
                                <Text>
                                    <strong>Data assegnazione:</strong> {new Date(request.assignedAt).toLocaleDateString()}
                                </Text>

                                {/* Se la scheda di allenamento è assegnata, visualizzala */}
                                {request.workoutPlanId && (
                                    <>
                                        <Typography.Title level={5} style={{ marginTop: '1rem' }}>
                                            Scheda Assegnata: {request.workoutPlanId.workoutPlanName || 'Nome non disponibile'}
                                        </Typography.Title>
                                    </>
                                )}

                            </Card>
                        ))
                    ) : (
                        <Typography>Nessuna richiesta completata trovata.</Typography>
                    )
                )}
            </Content>
        </Layout>
    );
};

export default TrainerHistory;
